module.exports = __webpack_public_path__ + "static/media/putter-breakdown.0c844b67.png";